export default __webpack_public_path__ + "static/picto-attach-906d47380f2fc6bd6a0342641ac2fbe5.png";